export default {"src":"/_next/static/media/StoreHero.dbf3e15b.svg","height":300,"width":472};